import * as React from "react";
import { observer, inject } from "mobx-react";
import { ISharedValuesStore } from "../Stores/SharedValuesStore";
import { SimpleModal } from "../Components/SimpleModal/SimpleModal";
import { STModalWrapper, STTypography } from "./styles";
import { SharedValues } from "../Tools/SharedValues";
import { ButtonsForm } from "../Components/ButtonsForm/ButtonsForm";

interface IProps {
  sharedValues?: ISharedValuesStore;
}

@inject("sharedValues")
@observer
export default class SessionTimeoutModal extends React.Component<IProps> {
  handleClose = () => {
    this.props.sharedValues.isSessionValid = true;
  };

  handleOpen = () => {
    this.props.sharedValues.isSessionValid = false;
  };

  handleSubmit = async () => {
    await this.props.sharedValues.signOut();
    this.props.sharedValues.isSessionValid = true;
  };

  render() {
    return (
      <React.Fragment>
        <SimpleModal width={350} isOpened={!this.props.sharedValues.isSessionValid} onClose={this.handleClose}>
          <STModalWrapper container>
            <STTypography>{SharedValues.getLocalizationValue("sessionTimeout")}</STTypography>
            <ButtonsForm onClose={this.handleClose} onSubmit={this.handleSubmit} />
          </STModalWrapper>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
